// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__eAGW1","header":"ReportDetails_header__2AFf0","title":"ReportDetails_title__2b9RE","left":"ReportDetails_left__38dlb"};